// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/1100338fbf9d9d0cd525.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"74e68a67f3a8d420508d","130":"747bd3274727cbed2b60","131":"cb54cc2e01168caa05b6"}[chunkId] + ".chunk.js";
};